<dv-form-wrapper>
  <dv-form-sections
    vtFormTranslate
    [formGroup]="formGroup"
    [formSections]="[
      { elements, title: 'VippsIntegration.FormTitle', isCollapsable: false },
    ]"></dv-form-sections>
</dv-form-wrapper>
<dv-save-panel
  labelCancel=""
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  labelSave="{{ 'General.Save' | translate }}"
  (save)="save()">
</dv-save-panel>
